/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_CompleteInputs */

const en_load_project_file_status_complete = /** @type {(inputs: Load_Project_File_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project import complete...`)
};

const fr_load_project_file_status_complete = /** @type {(inputs: Load_Project_File_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation du projet terminee...`)
};

const de_load_project_file_status_complete = /** @type {(inputs: Load_Project_File_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektimport abgeschlossen...`)
};

const it_load_project_file_status_complete = /** @type {(inputs: Load_Project_File_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione del progetto completata...`)
};

const ru_load_project_file_status_complete = /** @type {(inputs: Load_Project_File_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт проекта завершен...`)
};

const es_load_project_file_status_complete = /** @type {(inputs: Load_Project_File_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación del proyecto completada...`)
};

const zh_cn2_load_project_file_status_complete = /** @type {(inputs: Load_Project_File_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目导入完成……`)
};

const ja_load_project_file_status_complete = /** @type {(inputs: Load_Project_File_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトのインポートが完了しました...`)
};

const hi_load_project_file_status_complete = /** @type {(inputs: Load_Project_File_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट का आयात पूरा हो गया...`)
};

const pt_pt2_load_project_file_status_complete = /** @type {(inputs: Load_Project_File_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação do projeto concluída...`)
};

/**
* | output |
* | --- |
* | "Project import complete..." |
*
* @param {Load_Project_File_Status_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_complete = /** @type {((inputs?: Load_Project_File_Status_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_status_complete(inputs)
	if (locale === "de") return de_load_project_file_status_complete(inputs)
	if (locale === "it") return it_load_project_file_status_complete(inputs)
	if (locale === "ru") return ru_load_project_file_status_complete(inputs)
	if (locale === "es") return es_load_project_file_status_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_status_complete(inputs)
	if (locale === "ja") return ja_load_project_file_status_complete(inputs)
	if (locale === "hi") return hi_load_project_file_status_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_status_complete(inputs)
	return en_load_project_file_status_complete(inputs)
});